import React from 'react';
import {CircularProgress} from "@material-ui/core";
import axios from 'axios';
import TextField from "@material-ui/core/TextField";
import {Button} from "@material-ui/core";
import {ServiceLocator} from "../../Services/ServiceLocator";
import { v4 as uuid } from 'uuid';
import WorkshopTemplate from "./WorkshopTemplate";

import { AuthenticationService } from "../../Services/AuthenticationService";
import {getNumberInputDisplayValue, parseNumberInputValue} from '../../utils/numberInputUtils';
import { toUtcForStorage } from '../../utils/dateUtils';
let assemblies = [];
let subAssemblies = [];
let assembly;
let subAssembly;

class Unpackage extends React.Component {
    state = {
        loading: true,
        savingLog: false,
        quantity: 0
    };

    constructor(props) {
        super(props);
        globalProps = props;

        const jwtToken = AuthenticationService.getInstance().getToken();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const self = this;

        self.setState({loading: true});
        Promise.all([self.loadAssemblies(), self.loadSubAssemblies()]).then(() => {
            const assemblyId = globalProps.match.params.assemblyId;
            assembly = assemblies.find(x => x.assembly.id === assemblyId);
            subAssembly = subAssemblies.find(x => x.subAssembly.id === assemblyId);
            self.setState({assembly: assembly ? assembly.assembly : null, subAssembly: subAssembly ? subAssembly.subAssembly : null, loading: false});
        });
    };

    loadAssemblies = () => {
        const assemblyService = ServiceLocator.Instance.getAssemblyService();

        return assemblyService.getAllAssembliesExpanded().then((assembliesResult) => {
            assemblies = assembliesResult;
        });
    };

    loadSubAssemblies = () => {
        const assemblyService = ServiceLocator.Instance.getAssemblyService();

        return assemblyService.getAllSubAssembliesExpanded().then((subAssembliesResult) => {
            subAssemblies = subAssembliesResult;
        });
    };

    addUnpackageLog = () => {
        const self = this;
        const parsedQuantity = parseNumberInputValue(this.state.quantity);
        if (parsedQuantity < 1) return window.$alertWarning("You must select or enter a quantity");

        self.setState({savingLog: true});
        const payload = {
            id: uuid(),
            assemblyId: this.state.assembly ? this.state.assembly.id : null,
            subAssemblyId: this.state.subAssembly ? this.state.subAssembly.id : null,
            quantity: parsedQuantity * -1,
            logDate: toUtcForStorage(new Date()),
            reason: ''
        };
        const assemblyService = ServiceLocator.Instance.getAssemblyService();
        assemblyService.createPackageLog(payload).then(() => {
            window.$alertSuccess("Unpackage log created");
            self.setState({savingLog: false, completed: true});
        });
    };

    render() {
        const self = this;
        if (this.state.loading) {
            return (
                <WorkshopTemplate>
                    <div className="mobile-container">
                        <CircularProgress/>
                    </div>
                </WorkshopTemplate>
            );
        }

        const assemblyId = globalProps.match.params.assemblyId;

        if (this.state.completed) {
            return (
                <WorkshopTemplate>
                    <div className="mobile-container">
                        <h2>Log complete!</h2>
                        <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={() => globalProps.history.push(`/search/${assemblyId}`)}
                            className="success-button-lg"
                        >
                            Assembly Home
                        </Button>
                        <br/><br/>
                    </div>
                </WorkshopTemplate>
            );
        }

        const {assembly, subAssembly} = self.state;

        if (!assembly && !subAssembly) {
            return (
                <WorkshopTemplate>
                    <div className="mobile-container">
                        <h2>Invalid URL</h2>
                    </div>
                </WorkshopTemplate>
            );
        }

        return (
            <WorkshopTemplate>
                <div className="mobile-container">
                    {assembly ?
                        <div>
                            <Button 
                                variant="contained" 
                                color="primary" 
                                onClick={() => globalProps.history.push(`/search/${assembly.id}`)}
                                className="success-button-lg"
                            >
                                Assembly Home
                            </Button>
                            <h2>Unpackaging<br/>{assembly.assemblyId} rev {assembly.revision}</h2>
                            <div style={{marginTop: -8, marginBottom: 14, color: '#666'}}>
                                {assembly.description || 'No description'}
                            </div>
                        </div>
                        : ""}
                    {subAssembly ?
                        <div>
                            <Button 
                                variant="contained" 
                                color="primary" 
                                onClick={() => globalProps.history.push(`/search/${subAssembly.id}`)}
                                className="success-button-lg"
                            >
                                Assembly Home
                            </Button>
                            <h2>Unpackaging<br/>{subAssembly.subAssemblyId} rev {subAssembly.revision}</h2>
                            <div style={{marginTop: -8, marginBottom: 14, color: '#666'}}>
                                {subAssembly.description || 'No description'}
                            </div>
                        </div>
                        : ""}
                    <Button 
                        variant="contained" 
                        color="primary"
                        className="success-button-lg quantity-button" 
                        style={{margin: 10}}
                        onClick={(event) => {this.setState({quantity: (parseNumberInputValue(this.state.quantity) + 1).toString()})}}
                    >
                        1
                    </Button>
                    <Button 
                        variant="contained" 
                        color="primary"
                        className="success-button-lg quantity-button" 
                        style={{margin: 10}}
                        onClick={(event) => {this.setState({quantity: (parseNumberInputValue(this.state.quantity) + 2).toString()})}}
                    >
                        2
                    </Button>
                    <Button 
                        variant="contained" 
                        color="primary"
                        className="success-button-lg quantity-button" 
                        style={{margin: 10}}
                        onClick={(event) => {this.setState({quantity: (parseNumberInputValue(this.state.quantity) + 4).toString()})}}
                    >
                        4
                    </Button>
                    <Button 
                        variant="contained" 
                        color="primary"
                        className="success-button-lg quantity-button" 
                        style={{margin: 10}}
                        onClick={(event) => {this.setState({quantity: (parseNumberInputValue(this.state.quantity) + 10).toString()})}}
                    >
                        10
                    </Button>
                    <Button 
                        variant="contained" 
                        color="primary"
                        className="success-button-lg quantity-button" 
                        style={{margin: 10}}
                        onClick={(event) => {this.setState({quantity: (parseNumberInputValue(this.state.quantity) + 20).toString()})}}
                    >
                        20
                    </Button>
                    <Button 
                        variant="contained" 
                        color="primary"
                        className="success-button-lg quantity-button" 
                        style={{margin: 10}}
                        onClick={(event) => {this.setState({quantity: (parseNumberInputValue(this.state.quantity) + 100).toString()})}}
                    >
                        100
                    </Button>
                    <br /><br />
                    <TextField
                        placeholder="Quantity Unpackaged"
                        label="Quantity Unpackaged"
                        variant="outlined" inputProps={{ inputMode: 'numeric' }}
                        onChange={(event) => this.setState({quantity: event.target.value})}
                        value={this.state.quantity || ''}
                        autoComplete="off"
                    />
                    <br/><br/>
                    {this.state.savingLog === true ?
                        <CircularProgress />
                        :
                        <Button 
                            variant="contained" 
                            color="primary"
                            className="success-button-lg"
                            onClick={this.addUnpackageLog}
                        >
                            Save
                        </Button>
                    }
                    <br/><br/>
                </div>
            </WorkshopTemplate>
        );
    }
}

let globalProps;

export default Unpackage;
